import React, { useEffect, useRef, useState } from 'react'
import 'react-quill/dist/quill.snow.css';
import ReactQuill, { Quill } from 'react-quill';
import { useNavigate } from 'react-router-dom';
import ImgCrop from 'antd-img-crop';

import useAttractions from '../../../../../hooks/useAttractions'
import useDestinations from '../../../../../hooks/useDestinations';

import { ACTIVE, INACTIVE, PENDING } from '../../../../../Constants/activeStatusType';
import { ATTRACTTIONS_CONTAINER, handleDeleteBlob, handleImageUpload } from '../../../../../azure/blob';

import { Button, Col, Form, Image, Input, notification, Row, Select, Spin, Upload } from 'antd'
import { PlusOutlined } from '@ant-design/icons';

import { attractionTypes, weatherTypes } from '../../../../../Constants/itemTypes';

import './styles.scss'
import { editAttraction, getAttractionById } from '../../../../../../redux/api/attractions.api';
import { useDispatch } from 'react-redux';
import { fetchDestinationNamesAC } from '../../../../../../redux/actions/destinations/destinations.ac';

const getOptionName = (value) => {
    return value
        .toLowerCase()
        .replace(/_./g, (match) => ' ' + match.charAt(1).toUpperCase())
        .replace(/^\w/, (c) => c.toUpperCase());
};


const weatherOptions = Object.keys(weatherTypes).map(key => {
    return {
        label: getOptionName(weatherTypes[key]),
        value: key
    };
});

const attractionOptions = Object.keys(attractionTypes).map(key => {
    return {
        label: getOptionName(attractionTypes[key]),
        value: key
    };
});

const quillModules = {
    toolbar: [
        [{ font: [] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ align: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ script: "sub" }, { script: "super" }],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image", "video"],
        ["clean"],
        ["formula"],
        [{ size: ["small", false, "large", "huge"] }],
    ],
    clipboard: {
        matchVisual: false
    },
    imageResize: {
        parchment: Quill.import('parchment'),
        modules: ['Resize', 'DisplaySize']
    }
};

const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });


const EditAttraction = () => {
    const [shortDescriptionCharCount, setShortDescriptionCharCount] = useState(0)
    const [longDescriptionCharCount, setLongDescriptionCharCount] = useState(0)
    const [fileList, setFileList] = useState([])
    const [videoList, setVideoList] = useState([])
    const [thumbnailFile, setThumbnailFile] = useState([]);
    const [previewImage, setPreviewImage] = useState('');
    const [previewOpen, setPreviewOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const [loadingText, setLoadingText] = useState('')
    const topRef = useRef(null);
    const [api, contextHolder] = notification.useNotification();
    const navigate = useNavigate();
    const destinations = useDestinations()
    const destinationNames = destinations.destinationNames
    const attractions = useAttractions().attractions
    const url = window.location.pathname
    const [attraction, setAttraction] = useState()
    const attractionId = url.split('/').pop()
    const formRef = useRef(null)
    const dispatch = useDispatch()

    useEffect(() => {
        if (attractions?.length > 0) {
            const attraction = attractions.find(attraction => attraction.id === attractionId)
            if (attraction) {
                setAttraction(attraction)
            } else {
                handleGetAttraction(attractionId)
            }
        } else {
            handleGetAttraction(attractionId)
        }

        if (destinationNames?.length === 0) {
            dispatch(fetchDestinationNamesAC())
        }
    }, [])

    useEffect(() => {
        if (attraction) {
            formRef.current.setFieldsValue({
                attractionName: attraction.attractionName,
                destinationId: attraction.destinationId,
                tags: attraction.tags.split(','),
                attractionDescriptionShort: attraction.attractionDescriptionShort,
                attractionDescription: attraction.attractionDescription,
                rules: attraction.rules,
                attractionType: attraction.attractionType,
                attractionCity: attraction.attractionCity,
                attractionCoordinates: attraction.attractionCoordinates,
                mapLocation: attraction.mapLocation,
                weather: attraction.weather,
                ticketPrice: attraction.ticketPrice,
                activeStatus: attraction.activeStatus,
            })

            if (attraction.attractionImages) {
                const images = attraction.attractionImages.split(',')
                const fileList = images.map((url, index) => {
                    return {
                        uid: index,
                        name: `image_${index}.png`,
                        status: 'done',
                        url: url
                    }
                })
                setFileList(fileList)
            }

            if (attraction.attractionVideos) {
                const videos = attraction.attractionVideos.split(',')
                const fileList = videos.map((url, index) => {
                    return {
                        uid: index,
                        name: `video_${index}.mp4`,
                        status: 'done',
                        url: url
                    }
                })
                setVideoList(fileList)
            }

            if (attraction.thumbnailUrl) {
                const fileList = [{
                    uid: 0,
                    name: 'thumbnail.png',
                    status: 'done',
                    url: attraction.thumbnailUrl
                }]
                setThumbnailFile(fileList)
            }
        }
    }, [attraction])

    const handleGetAttraction = async (id) => {
        setLoading(true)
        try {
            const destination = await getAttractionById(id)
            setAttraction(destination.data[0])
        } catch (error) {
            console.error('Error fetching destination', error)
        }
        setLoading(false)
    }

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };

    const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);

    const onVideoChange = ({ fileList: newFileList }) => setVideoList(newFileList);

    const onThumbnailChange = ({ fileList: newFileList }) => setThumbnailFile(newFileList);


    const onFinish = async (values) => {
        topRef.current.scrollTo(0, 0);
        setLoading(true);
        try {
            Object.keys(values).forEach(key => (values[key] === undefined || values[key] === '' || values[key] === null) && delete values[key]);

            let imageUrls = [];
            let videoUrls = [];
            let thumbnailUrl = '';

            const name = values.attractionName.replace(/\s/g, '_').toLowerCase();

            // find new images and list images need to be deleted
            const newImages = fileList.filter(file => !file.url);
            const deletedImages = attraction.attractionImages?.split(',').filter(image => !fileList.find(file => file.url === image));

            // find new videos and list videos need to be deleted
            const newVideos = videoList.filter(file => !file.url);
            const deletedVideos = attraction.attractionVideos?.split(',').filter(video => !videoList.find(file => file.url === video));

            // find new thumbnail and list thumbnail need to be deleted
            const newThumbnail = thumbnailFile.filter(file => !file.url);
            const deletedThumbnail = attraction.thumbnailUrl?.split(',').filter(thumbnail => !thumbnailFile.find(file => file.url === thumbnail));

            if (newImages?.length > 0) {
                setLoadingText('Uploading Attraction Images');
                const imageUploadPromises = newImages.map(async (file, index) => {
                    setLoadingText(`Uploading image ${index + 1}`);
                    return handleImageUpload(
                        ATTRACTTIONS_CONTAINER,
                        file.originFileObj,
                        file.size,
                        `${name}_${file.name}`
                    ).then((response) => {
                        imageUrls.push(response.blockBlobClient.url);
                    });
                });
                await Promise.all(imageUploadPromises);
            }

            if (newVideos?.length > 0) {
                setLoadingText('Uploading Attraction Videos');
                const videoUploadPromises = newVideos.map(async (file, index) => {
                    setLoadingText(`Uploading video ${index + 1}`);
                    return handleImageUpload(
                        ATTRACTTIONS_CONTAINER,
                        file.originFileObj,
                        file.size,
                        `${name}_${file.name}`
                    ).then((response) => {
                        videoUrls.push(response.blockBlobClient.url);
                    });
                });
                await Promise.all(videoUploadPromises);
            }

            if (newThumbnail?.length > 0) {
                setLoadingText('Uploading Attraction Thumbnail');
                const thumbnailUploadPromises = newThumbnail.map(async (file, index) => {
                    setLoadingText(`Uploading thumbnail ${index + 1}`);
                    return handleImageUpload(
                        ATTRACTTIONS_CONTAINER,
                        file.originFileObj,
                        file.size,
                        `${name}_${file.name}`
                    ).then((response) => {
                        thumbnailUrl = response.blockBlobClient.url;
                    });
                });
                await Promise.all(thumbnailUploadPromises);
            }

            // delete blobs
            if (deletedImages?.length > 0) {
                setLoadingText('Deleting Attraction Images');
                const imageDeletePromises = deletedImages.map(async (image, index) => {
                    const blobName = getBlobName(image);
                    setLoadingText(`Deleting image ${index + 1}`);
                    return handleDeleteBlob(ATTRACTTIONS_CONTAINER, blobName);
                });
                await Promise.all(imageDeletePromises);
            }

            if (deletedVideos?.length > 0) {
                setLoadingText('Deleting Attraction Videos');
                const videoDeletePromises = deletedVideos.map(async (video, index) => {
                    const blobName = getBlobName(video);
                    setLoadingText(`Deleting video ${index + 1}`);
                    return handleDeleteBlob(ATTRACTTIONS_CONTAINER, blobName);
                });
                await Promise.all(videoDeletePromises);
            }

            if (deletedThumbnail?.length > 0) {
                setLoadingText('Deleting Attraction Thumbnail');
                const thumbnailDeletePromises = deletedThumbnail.map(async (thumbnail, index) => {
                    const blobName = getBlobName(thumbnail);
                    setLoadingText(`Deleting thumbnail ${index + 1}`);
                    return handleDeleteBlob(ATTRACTTIONS_CONTAINER, blobName);
                });
                await Promise.all(thumbnailDeletePromises);
            }

            let updatedImages = [
                ...fileList.filter((file) => file.url).map((file) => file.url),
                ...imageUrls
            ];

            let updatedVideos = [
                ...videoList.filter((file) => file.url).map((file) => file.url),
                ...videoUrls
            ];

            // Ensure thumbnailUrl is a single string
            let updatedThumbnail = thumbnailUrl || (thumbnailFile[0]?.url || '');

            // remove unwanted parts from urls
            updatedImages.forEach((url, index) => {
                updatedImages[index] = sanitizeBlobUrls(url);
            });

            updatedVideos.forEach((url, index) => {
                updatedVideos[index] = sanitizeBlobUrls(url);
            });

            updatedThumbnail = sanitizeBlobUrls(updatedThumbnail);

            const data = {
                id: attraction.id,
                destinationId: values.destinationId,
                attractionName: values.attractionName,
                tags: values.tags.join(','),
                attractionDescriptionShort: values.attractionDescriptionShort,
                attractionDescription: values.attractionDescription,
                attractionType: values.attractionType.toString(),
                attractionCity: values.attractionCity,
                attractionCoordinates: values.attractionCoordinates,
                mapLocation: values.mapLocation,
                weather: values.weather,
                rules: values.rules,
                ticketPrice: values.ticketPrice,
                activeStatus: values.activeStatus,
                attractionImages: updatedImages?.length > 0 ? updatedImages.join(',') : null,
                attractionVideos: updatedVideos?.length > 0 ? updatedVideos.join(',') : null,
                thumbnailUrl: updatedThumbnail === '' ? null : updatedThumbnail
            }

            const response = await editAttraction(data);
            if (response.status === 200) {
                api.success({
                    message: 'Attraction Updated Successfully',
                    description: 'You have successfully updated the attraction',
                });

                setTimeout(() => {
                    navigate(`/dashboard/tours/attractions/${attraction.id}`);
                }, 2000);
            } else {
                console.log('Error', response);
                api.error({
                    message: 'Error Adding Destination',
                    description: 'There was an error updating the attraction. Please try again'
                });
            }
        } catch (error) {
            console.log('Error', error);
            api.error({
                message: 'Error!',
                description: 'Failed to update the attraction. Please try again.',
            });
        }
        setLoading(false);
        setLoadingText('');
    };

    const getBlobName = (blobUrl) => {
        const splitUrl = blobUrl.split('/')
        return splitUrl[splitUrl.length - 1]
    }

    const sanitizeBlobUrls = (blobUrl) => {
        const splitUrl = blobUrl.split('?')
        return splitUrl[0]
    }

    const destinationOptions = Object.keys(destinationNames).map(key => {
        return {
            label: getOptionName(destinationNames[key].destinationName),
            value: destinationNames[key].id
        };
    });

    return (
        <div className='add__destination' ref={topRef}>
            {contextHolder}
            <h2>Edit Attraction</h2>

            <Spin spinning={loading} tip={loadingText}>
                <Form
                    layout='vertical'
                    onFinish={onFinish}
                    ref={formRef}
                >
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label='Attraction Name'
                                name='attractionName'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please enter attraction name'
                                    }
                                ]}
                            >
                                <Input placeholder='Attraction Name' showCount maxLength={200} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label='Destination'
                                name='destinationId'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select destination'
                                    }
                                ]}
                            >
                                <Select
                                    showSearch
                                    style={{
                                        width: '100%',
                                    }}
                                    placeholder="Select Destination"
                                    options={destinationOptions}
                                    maxCount={1}
                                    filterOption={(input, option) => { return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label={`Attraction Short Description ( ${shortDescriptionCharCount}/1000 characters)`}
                                name='attractionDescriptionShort'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please enter attraction short description'
                                    }
                                ]}
                            >
                                <ReactQuill
                                    theme="snow"
                                    limits={{ maxLength: 500 }}
                                    onChange={(content, delta, source, editor) => {
                                        setShortDescriptionCharCount(editor.getLength())
                                    }}
                                    modules={quillModules}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label={`Attraction Description ( ${longDescriptionCharCount}/10000 characters)`}
                                name='attractionDescription'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please enter attraction description'
                                    }
                                ]}
                            >
                                <ReactQuill
                                    theme="snow"
                                    limits={{ maxLength: 10000 }}
                                    onChange={(content, delta, source, editor) => {
                                        setLongDescriptionCharCount(editor.getLength())
                                    }}
                                    modules={quillModules}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label={`Attraction Rules ( ${longDescriptionCharCount}/500 characters)`}
                                name='rules'
                            >
                                <ReactQuill
                                    theme="snow"
                                    limits={{ maxLength: 500 }}
                                    onChange={(content, delta, source, editor) => {
                                        setLongDescriptionCharCount(editor.getLength())
                                    }}
                                    modules={quillModules}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label='Attraction Type'
                                name='attractionType'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select attraction type'
                                    }
                                ]}
                            >
                                <Select
                                    showSearch
                                    allowClear
                                    style={{
                                        width: '100%',
                                    }}
                                    placeholder="Add Attraction Type"
                                    options={attractionOptions}
                                    maxCount={1}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label='Attraction City'
                                name='attractionCity'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please add attraction city'
                                    }
                                ]}
                            >
                                <Input placeholder='Attraction City' showCount maxLength={50} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label='Attraction Coordinates'
                                name='attractionCoordinates'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input attraction coordinates'
                                    }
                                ]}
                            >
                                <Input placeholder='Attraction Coordinates' showCount maxLength={50} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label='Attraction Map Location'
                                name='mapLocation'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please add attraction map location'
                                    }
                                ]}
                            >
                                <Input placeholder='Attraction Map Location' />
                            </Form.Item>
                        </Col>
                    </Row>


                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label='Destination Weather'
                                name='weather'
                            >
                                <Select
                                    showSearch
                                    allowClear
                                    style={{
                                        width: '100%',
                                    }}
                                    placeholder="Add weather"
                                    options={weatherOptions}
                                    maxCount={1}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label='Ticket Price (in USD). Add 0 if free'
                                name='ticketPrice'
                            >
                                <Input type='number' placeholder='Ticket Price' showCount maxLength={50} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label='Attraction Tags'
                                name='tags'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please add tags'
                                    }
                                ]}
                            >
                                <Select
                                    mode="tags"
                                    style={{
                                        width: '100%',
                                    }}
                                    placeholder="Add attraction tags"
                                    options={[]}
                                    maxCount={5}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label='Upload Attraction Images (Max 10)'
                                name='attractionImages'
                            >
                                <Upload
                                    listType="picture-card"
                                    fileList={fileList}
                                    onPreview={handlePreview}
                                    onChange={handleChange}
                                    multiple={true}
                                    maxCount={10}
                                    beforeUpload={(file) => {
                                        return false;
                                    }}
                                >
                                    {fileList.length <= 10 && '+ Upload'}
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label='Upload Attraction Videos (Max 3)'
                                name='attractionVideos'
                            >
                                <Upload
                                    listType="picture"
                                    fileList={videoList}
                                    onChange={onVideoChange}
                                    multiple={true}
                                    maxCount={3}
                                    beforeUpload={(file) => {
                                        return false;
                                    }}
                                >
                                    {videoList?.length < 3 && <Button icon={<PlusOutlined />}>Upload</Button>}
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label='Upload Attraction Thumbnail Image'
                                name='thumbnailUrl'
                            >
                                <ImgCrop
                                    rotationSlider
                                    modalTitle='Crop Image'
                                    modalOk='Crop'
                                    modalCancel='Cancel'
                                    showReset={true}
                                    aspect={16 / 9}
                                >
                                    <Upload
                                        listType="picture-card"
                                        fileList={thumbnailFile}
                                        onChange={onThumbnailChange}
                                        multiple={false}
                                        beforeUpload={(file) => {
                                            return false;
                                        }}
                                    >
                                        {thumbnailFile.length < 1 && '+ Upload'}
                                    </Upload>
                                </ImgCrop>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Col span={12}>
                        <Form.Item
                            label='Active Status'
                            name='activeStatus'
                            rules={[
                                {
                                    required: true,
                                    message: 'Please select active status'
                                }
                            ]}
                        >
                            <Select
                                showSearch
                                allowClear
                                style={{
                                    width: '100%',
                                }}
                                placeholder="Select Active Status"
                                options={[
                                    {
                                        label: 'Active',
                                        value: ACTIVE
                                    },
                                    {
                                        label: 'Inactive',
                                        value: INACTIVE
                                    },
                                    {
                                        label: 'Pending',
                                        value: PENDING
                                    }
                                ]}
                                maxCount={1}
                            />
                        </Form.Item>
                    </Col>

                    <Form.Item>
                        <Button type='primary' htmlType='submit'>
                            Update Attraction
                        </Button>
                    </Form.Item>
                </Form>
            </Spin>

            {previewImage && (
                <Image
                    wrapperStyle={{
                        display: 'none',
                    }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) => !visible && setPreviewImage(''),
                    }}
                    src={previewImage}
                />
            )}
        </div>
    )
}

export default EditAttraction